module.exports = __webpack_public_path__ + "static/media/point.04b2fde1.png";